import { getSelectedAssociatedCustomer } from "../../components/common/helper/helper";
import { getHeaderToken } from "../selectors/navItems.selector";
import {
  apiHeaderWithSiteId,
  clearCartAPIUrl,
  getCartAPIUrl,
  updateCartAPIUrl,
  updateSuggestedOrderStatusAPIUrl,
  getCartItemCountAPIUrl
} from "./../../utils/urls";
import { deleteOrderDataAction } from "./orderHistory.actions";
import { loadingEnd, loadingStart } from "./root.actions";
import { clearCNYShipToAddressAction } from "./cnyShipToAddress.actions";
export const cartItemsActionTypes = {
  FETCH_CART_ITEMS_SUCCESS: "FETCH_CART_ITEMS_SUCCESS",
  FETCH_CART_ITEMS_FAILURE: "FETCH_CART_ITEMS_FAILURE",
  ADD_CART_ITEMS_SUCCESS: "ADD_CART_ITEMS_SUCCESS",
  ADD_CART_ITEMS_FAILURE: "ADD_CART_ITEMS_FAILURE",
  GET_CART_ITEMS_SUCCESS: "GET_CART_ITEMS_SUCCESS",
  GET_CART_ITEMS_FAILURE: "GET_CART_ITEMS_FAILURE",
  FETCH_CART_CARTITEMS_SUCCESS: "FETCH_CART_CARTITEMS_SUCCESS",
};

const fetchCartItemsDataSuccessAction = (data, productsCount = null) => {
  return {
    type: cartItemsActionTypes.FETCH_CART_ITEMS_SUCCESS,
    data,
    productsCount,
  };
};

const fetchCartCartItemsDataSuccessAction = (data) => {
  return {
    type: cartItemsActionTypes.FETCH_CART_CARTITEMS_SUCCESS,
    data,
  };
};

// TO CALCULATE THE NUMBER OF PRODUCTS AND TOTAL QUANTITY OF EACH PRODUCT
const calculateProductsWithCount = (items) => {
  return (items || []).reduce((acc, cartData) => {
    const count = parseInt(cartData.count) || 0;
    return {
      ...acc,
      [cartData.id]: count,
      // TO CALCUALTE THE NUMBER OF PRODUCTS
      defaultCount: (acc.defaultCount || 0) + 1,
      // TO CALCULATE THE TOTAL QUANTITY OF EACH PRODUCT
      totalQuantityCount: (acc.totalQuantityCount || 0) + count
    };
  }, { defaultCount: 0, totalQuantityCount: 0 });
}

//Product Listing Page on Add to Cart Button
export const moveCartToCartItemsDataAction =
  (isAuth, token, orderType = "ZOR", isBNCProduct = false, isBNCMultiProduct = false) =>
  async (dispatch, getState) => {
    const latestState = getState();

    // Remove CNY products from cart if any & add normal products to cart
    const cart = latestState.cart.items.filter(item => item?.isCNYSuggestedOrder !== true);
    
    // If there were CNY products, clear the CNY ship-to address
    const hasCNYProducts = latestState.cart.items.some(item => item?.isCNYSuggestedOrder === true);
    if (hasCNYProducts) {
      dispatch(clearCNYShipToAddressAction());
    } 

    // get product id and update count
    let updateCartPayload = {
      orderType: orderType,
      isBNCFlag: isBNCProduct ? true : false,
      isBNCMultiFlag: isBNCMultiProduct ? true : false,
      multipackType: isBNCMultiProduct ? "BNC_MULTIPACK" : "",
      items: cart.map((cartData) => ({
        id: cartData?.id,
        quantity:
          cartData?.count === 0 || cartData?.count === "" ? 0 : cartData?.count,
        unitType: cartData?.unitType
          ?.filter((type) => type.active === 1)
          ?.map((singleUnitType) => {
            return singleUnitType.key;
          })[0],
      })),
    };

    let headers = apiHeaderWithSiteId;
    if (isAuth && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(updateCartAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(updateCartPayload),
    })
    .then((response) => response.json())
    .then(async (data) => {
      dispatch(loadingEnd());
      if (data && data.success === false) {
        return data;
      }

      // Calculate products count using the helper function
      const productsCount = await calculateProductsWithCount(data.items);
      dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
      return data;
    })
    .catch((err) => console.log(err));
  };

// Add Special Products To Cart
export const moveSpecialCartToCartItemsDataAction =
  (isAuth, token, orderType = "ZOR", isSpecialBNCProduct = false, isSpecialBNCMultiProduct = false) =>
  async (dispatch, getState) => {
    const latestState = getState();
    const specialCart = latestState.specialCart.items;

    // get product id and update count
    let updateCartPayload = {
      orderType: orderType,
      isBNCFlag: isSpecialBNCProduct ? isSpecialBNCProduct : false,
      isBNCMultiFlag: isSpecialBNCMultiProduct ? isSpecialBNCMultiProduct : false,
      multipackType: isSpecialBNCMultiProduct ? "BNC_MULTIPACK" : "",
      items: specialCart.map((cartData) => ({
        id: cartData.id,
        quantity:
          cartData.count === 0 || cartData.count === "" ? 0 : cartData.count,
        unitType: cartData.unitType
          .filter((type) => type.active === 1)
          .map((singleUnitType) => {
            return singleUnitType.key;
          })[0],
      })),
    };

    let headers = apiHeaderWithSiteId;
    if (isAuth && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(updateCartAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(updateCartPayload),
    })
      .then((response) => response.json())
      .then(async (data) => {
        dispatch(loadingEnd());
        if(data && data.success === false) {
          return data;
        }
        // Calculate products count using the helper function
        const productsCount = await calculateProductsWithCount(data.items);
        dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
        return data;
      })
      .catch((err) => console.log(err));
  };

// Clear Cart event of Cart Preview Page
// No need to pass token it is coming form selector
export const clearCartItemsDataAction =
  (token) => async (dispatch, getState) => {
    dispatch(loadingStart());
    let latestState = getState();
    token = getHeaderToken(latestState);
    latestState.cart.items = [];
    latestState.cartItems.items = [];
    latestState.cartItems.getCartAPI = null;
    if (latestState.cartItems.orderDetails) {
      latestState.cartItems.orderDetails = null;
    }
    if (latestState.checkOut) {
      latestState.checkOut = null;
    }
    if (latestState.cartItems.productsCount) {
      latestState.cartItems.productsCount = null;
    }
    if (latestState.product.items && latestState.product.items.items) {
      latestState.product.items.items.map((item) => {
        if (item.count > 0) {
          return (item.count = 0);
        }
        return "";
      });
    }

    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(clearCartAPIUrl, {
      method: "POST",
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        if(JSON.parse(localStorage.getItem("selectedSuggestedOrder"))) {
          let orderPayload = {
            suggestedOrderId: JSON.parse(localStorage.getItem("selectedSuggestedOrder")),
            isDelete: false,
            deleteType: "Temporary",
            orderNumber: ""
          };
          dispatch(updateSuggestedOrderStatusDataAction(token, orderPayload));
        }
        // Clear CNY shipTo address when cart is cleared
        dispatch(clearCNYShipToAddressAction());
        dispatch(fetchCartItemsDataSuccessAction(data));
        return data;
      })
      .catch((err) => console.log(err));
    dispatch(loadingEnd());
  };

/*
This action called from product page and special product
latestState.product.items.items.map will not update product count
Note: we can merge with clearCartItemsDataAction action also later
  */
export const clearCartFromProductDataAction =
  (token) => async (dispatch, getState) => {
    dispatch(loadingStart());
    let latestState = getState();
    token = getHeaderToken(latestState);
    latestState.cartItems.items = [];
    latestState.cartItems.getCartAPI = null;
    if (latestState.cartItems.orderDetails) {
      latestState.cartItems.orderDetails = null;
    }
    if (latestState.checkOut) {
      latestState.checkOut = null;
    }
    if (latestState.cartItems.productsCount) {
      latestState.cartItems.productsCount = null;
    }
    if(JSON.parse(localStorage.getItem("selectedSuggestedOrder"))) {
      let orderPayload = {
        suggestedOrderId: JSON.parse(localStorage.getItem("selectedSuggestedOrder")),
        isDelete: false,
        deleteType: "Temporary",
        orderNumber: ""
      };
      dispatch(updateSuggestedOrderStatusDataAction(token, orderPayload));
    }
    // if (latestState.product.items && latestState.product.items.items) {
    //   latestState.product.items.items.map((item) => {
    //     if (item.count > 0) {
    //       return (item.count = 0);
    //     }
    //     return "";
    //   });
    // }

    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(clearCartAPIUrl, {
      method: "POST",
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(loadingEnd());
        // Clear CNY shipTo address when cart is cleared
        dispatch(clearCNYShipToAddressAction());
        dispatch(fetchCartItemsDataSuccessAction(data));
        return data;
      })
      .catch((err) => console.log(err));
  };

export const updateCartItemsDataAction =
  (productInfo) => (dispatch, getState) => {
    const latestState = getState();
    const cartItem = latestState.cartItems.items.find(
      (item) => item.id === productInfo.id
    );
    if (!cartItem) {
      productInfo.count = parseInt(productInfo.count) + 1;
      latestState.cartItems.items.push(productInfo);
    }
    dispatch(loadingStart());
    // TODO: need to be changed to actual API call implementation
    // setTimeout is just for demonstration purposes
    setTimeout(() => {
      dispatch(loadingEnd());
      dispatch(fetchCartItemsDataSuccessAction(latestState.cartItems.items));
    }, 500);
  };

//Cart Preview Page Quantity Update
export const updateCartItemsInputDataAction =
  (productInfo, value, isAuth, token) =>
  async (dispatch, getState) => {
      const latestState = getState();
      const cartItems = latestState.cartItems.items;
      const cartAPIData = latestState.cartItems.getCartAPI;
      let qtyArr = [];
      if(Array.isArray(value)) {
        cartItems.map((cartItem, key) => {
          value.map((qtyObj, key) => {
            if(cartItem.id === qtyObj.id) {
              qtyArr.push(qtyObj.count);
            }
          });
        });
      }
      dispatch(loadingStart());
      let updateCartPayload = {
        isBNCFlag: cartAPIData.isBNCFlag,
        isBNCMultiFlag: cartAPIData.isBNCMultiFlag,
        multipackType: cartAPIData.isBNCMultiFlag ? "BNC_MULTIPACK" : "",
        orderType: cartAPIData.orderType,
        items: cartItems.map((cartItem, key) => ({
          id: cartItem.id,
          quantity: (Array.isArray(productInfo) 
          ? qtyArr[key]
          : cartItem.id === productInfo.id ? value : cartItem.count),
          unitType: cartItem?.unitType
            ?.filter((type) => type.active === 1)
            ?.map((singleUnitType) => {
              return singleUnitType.key;
            })[0],
        })),
      };

      if(cartAPIData?.isCNYSuggestedOrder) {
        updateCartPayload.isCNYSuggestedOrder = cartAPIData.isCNYSuggestedOrder;
        updateCartPayload.cnySuggestedOrderId = cartAPIData.cnySuggestedOrderId;
        updateCartPayload.isEditCNYSuggestedOrder = true;
      }

      let headers = apiHeaderWithSiteId;
      if (isAuth && token) {
        headers.Authorization = `Bearer ${token}`;
      }
      if (getSelectedAssociatedCustomer() !== null) {
        headers.AssociatedCustomer = getSelectedAssociatedCustomer();
      }

      return await fetch(updateCartAPIUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(updateCartPayload),
      })
        .then((response) => response.json())
        .then(async (data) => {
          dispatch(loadingEnd());
          if(data && data.success === false) {
            return data;  
          }
          // Calculate products count using the helper function
          const productsCount = await calculateProductsWithCount(data.items);
          dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
          return data;
        })
        .catch((err) => console.log(err));
  };

// Delete single cart item from Cart Preview Page
export const deleteCartItemsDataAction =
  (itemsId, token) =>
  async (dispatch, getState) => {
    dispatch(loadingStart());
    let latestState = getState();
    const cartAPIData = latestState.cartItems.getCartAPI;
    const items = (Array.isArray(itemsId)) ? itemsId 
    :  [{
        id: itemsId,
        quantity: 0,
      }]
    let updateCartPayload = {
      orderType: cartAPIData?.orderType,
      items: items,
      isBNCFlag: cartAPIData?.isBNCFlag,
      isBNCMultiFlag: cartAPIData?.isBNCMultiFlag,
      multipackType: cartAPIData?.isBNCMultiFlag ? "BNC_MULTIPACK" : "",
    };

    if(cartAPIData?.isCNYSuggestedOrder) {
      updateCartPayload.isCNYSuggestedOrder = cartAPIData.isCNYSuggestedOrder;
      updateCartPayload.cnySuggestedOrderId = cartAPIData.cnySuggestedOrderId;
      updateCartPayload.isEditCNYSuggestedOrder = true;
    }

    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(updateCartAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(updateCartPayload),
    })
      .then((response) => response.json())
      .then(async (data) => {
        dispatch(loadingEnd());
        if(data && data.success === false) {
          return data;  
        }
        // Calculate products count using the helper function
        const productsCount = await calculateProductsWithCount(data.items);
        latestState.cart.items = data.items;
        dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
        return data;
      })
      .catch((err) => console.log(err));
  };

// Decrease Product using (-) Button
export const decreaseCartItemsDataAction =
  (productInfo) => (dispatch, getState) => {
    let latestState = getState();
    let cartItem = latestState.cartItems.items.find(
      (item) => item.id === productInfo.id
    );
    if (cartItem) {
      cartItem.count--;
    }

    if (cartItem && cartItem.count === 0) {
      // remove cartItem.id from cart
      latestState.cartItems.items = latestState.cartItems.items.filter(
        (item) => item.id !== productInfo.id
      );
    }
    dispatch(loadingStart());

    // TODO: need to be changed to actual API call implementation
    setTimeout(() => {
      dispatch(loadingEnd());
      dispatch(fetchCartItemsDataSuccessAction(latestState.cartItems.items));
    }, 500);
  };

export const getCartItemsDataAction = (token) => async (dispatch) => {
  dispatch(loadingStart());
  try {
    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(getCartAPIUrl, {
      method: "GET",
      headers: headers,
    })
    .then((response) => response.json())
    .then(async (data) => {
        dispatch(loadingEnd());
        
        if (data && data.success === false) {
          return data;
        }
        // Calculate products count using the helper function
        const productsCount = await calculateProductsWithCount(data.items);
        dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
      return data;
    })
    .catch((err) => console.log(err));
  } catch (error) {
    dispatch(loadingEnd());
    return { success: false, error: 'Failed to fetch cart data.' };
  }
};

// Change Unitype in Cart Preview Page
export const updateUnitTypeDataAction =
  (productId, unitType) => (dispatch, getState) => {
    dispatch(loadingStart());
    const latestState = getState();

    // TO UPDATE CART ITEMS STORE
    latestState.cartItems.items.map((singleItem) => {
      return singleItem.id === productId
        ? singleItem.unitType.map((singleType) => {
            return singleType.key === unitType
              ? (singleType.active = 1)
              : singleType.key !== unitType
              ? (singleType.active = 0)
              : singleType.active;
          })
        : singleItem;
    });

    // TO UPDATE CART STORE
    latestState.cart.items.map((singleCartItem) => {
      return singleCartItem.id === productId
        ? singleCartItem.unitType.map((singleType) => {
            return singleType.key === unitType
              ? (singleType.active = 1)
              : singleType.key !== unitType
              ? (singleType.active = 0)
              : singleType.active;
          })
        : singleCartItem;
    });

    dispatch(
      fetchCartItemsDataSuccessAction(
        latestState.cartItems,
        latestState.cartItems.productsCount
      )
    );
    dispatch(loadingEnd());
  };

//Bulk Upload: Import Products To Cart
export const moveImportProductsToCartItemsDataAction =
  (updateCartPayload, isAuth, token) => async () => {
    let headers = apiHeaderWithSiteId;
    if (isAuth && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    await fetch(updateCartAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(updateCartPayload),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => console.log(err));
  };

// Update Suggested Order Data Status
export const updateSuggestedOrderStatusDataAction =
  (token, orderPayload) => async (dispatch, getState) => {
    dispatch(loadingStart());

    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(updateSuggestedOrderStatusAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(orderPayload),
    })
      .then((response) => response.json())
        .then((data) => {
          dispatch(loadingEnd());
          if(orderPayload.orderNumber === "" && orderPayload.deleteType === "Temporary" && orderPayload.isDelete) {
            let getSelectedOrderIds = JSON.parse(localStorage.getItem("selectedSuggestedOrder")) || [];
            getSelectedOrderIds = [...getSelectedOrderIds, ...orderPayload.suggestedOrderId];
            localStorage.setItem("selectedSuggestedOrder", JSON.stringify(getSelectedOrderIds));
          } else if(orderPayload.orderNumber === "" && orderPayload.deleteType === "Temporary" && !orderPayload.isDelete) {
            localStorage.removeItem("selectedSuggestedOrder");
          }
          return data;
        })
        .catch((err) => console.log(err));      
  };

// GET ONLY PRODUCTS COUNT ADDED IN THE CART (REPLACEMENT OF GET CART API TO REDUCE CALCULATION)
export const getCartItemCount = (token) => async (dispatch) => {
  dispatch(loadingStart());
  try {
    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    await fetch(getCartItemCountAPIUrl, {
      method: "GET",
      headers: headers,
    })
    .then((response) => response.json())
    .then(async (data) => {
        dispatch(loadingEnd());
        
        if (data && data.success === false) {
          return data;
        }
        // Calculate products count using the helper function
        const productsCount = await calculateProductsWithCount(data.items);
        dispatch(fetchCartItemsDataSuccessAction(data, productsCount));
      return data;
    })
    .catch((err) => console.log(err));
  } catch (error) {
    dispatch(loadingEnd());
    return { success: false, error: 'Failed to fetch cart count' };
  }
};

// Smart cart data fetcher that decides which API to call based on need
export const smartGetCartData = (needFullData = false, token) => async (dispatch) => {
  if (needFullData) {
    return dispatch(getCartItemsDataAction(token)); // Call getcart API to get full data
  }
  return dispatch(getCartItemCount(token)); // Call cartItemCount API to get only count
};